import PlaylistTrack from './playlistTrack';
import { useTranslations } from 'next-intl';
import styles from './styles/audio-player.module.scss';
import type { IAudioPlayerTrack } from '@metmuseum/types';

interface IProps {
	currentTrack: IAudioPlayerTrack;
	handleTrackChange: (id: string) => void;
	tracks: IAudioPlayerTrack[];
	playlistTitleOverride?: string;
}

const Playlist = (props: IProps) => {
	const t = useTranslations('audio');

	return (
		<ol className={styles.playlist}>
			{props.tracks.length && (
				<h4 className={styles.playlistTitle}>
					{props.playlistTitleOverride || t('playlist')}
				</h4>
			)}
			{props.tracks.map((playlistTrack) => (
				<PlaylistTrack
					isActive={playlistTrack.id === props.currentTrack.id}
					{...playlistTrack}
					handleTrackChange={props.handleTrackChange}
					key={playlistTrack.id}
				/>
			))}
		</ol>
	);
};

export default Playlist;
